import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaCuentaDocumentosDocumentoComponent {
  constructor ($api) {
    this.$api = $api
    this.documento = null
    this.onDelete = null
    this.eliminando = false
    this.src = null
    this.visualizando = false
  }

  $onChanges (changes) {
    if (changes.documento && this.documento)
      this.src = this.$api.link('/api/empresa/cuenta/documento', {
        id_empresa: this.documento.id_empresa,
        id_cuenta: this.documento.id_cuenta,
        id_documento: this.documento.id,
      })
  }

  eliminar (data) {
    this.eliminando = null

    if (data) {
      this.onDelete({$event: {data: data}})
    }
  }
}

module.component('empresaCuentaDocumentosDocumento', {
  controller: EmpresaCuentaDocumentosDocumentoComponent,
  template,
  bindings: {
    documento: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuenta/documentos/documento/component.js